import React from 'react';
import './style.css'
import {getRegisterState} from "../../features/model/selector/get-register-state/getRegisterState";
import {useAppSelector} from "../../common/hook";

export const SuccessfulRegistration = () => {

    const registerState = useAppSelector(getRegisterState);
    const email = registerState.email;

    return (
        <div className='registration-container'>
            <div className='successful-registration'>
                <p className='registration-title'>Подтвердите email</p>
                <span className='registration-text'>
                    Мы отправили письмо на адрес {email}.
                    Для завершения регистрации перейдите по ссылке из письма.
                </span>
            </div>
        </div>
    );
};